<template>
  <b-modal
    id="modal-cancel-topup"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
    body-class="px-[24px]"
  >
    <div class="gap-[8px] flex items-center mt-[16px]">
      <img
        src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg"
        alt="info-circle"
      >
      <div class="text-[#333333] text-[16px] font-semibold mt-[2px]">
        Cancel Top Up Kartu
      </div>
    </div>
    <div class="flex justify-center mt-[16px] px-[32px] text-[#626262]">
      <div>Are you sure you want to proceed? The transaction will be verified first and marked as <strong>“Refund”</strong> if the data matches</div>
    </div>
    <div class="flex justify-end gap-[8px] mt-[16px]">
      <b-button
        variant="outline-primary"
        @click="handleClose"
      >
        Cancel
      </b-button>
      <b-button
        :variant="loading ? 'secondary' : 'primary'"
        :disabled="loading"
        @click="onSubmit"
      >
        Confirm
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'

export default {
  props: {
    partnerIdx: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    handleClose() {
      this.$bvModal.hide('modal-cancel-topup')
    },
    async onSubmit() {
      this.loading = true
      const params = {
        id: this.partnerIdx,
        type: 'refund',
      }

      const url = 'komcards/api/v1/transactions/topup-idle'

      await newAxiosIns
        .post(url, params)
        .then(res => {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Success',
              icon: 'CheckIcon',
              variant: 'success',
              text: 'This transaction has been marked as “Refund”',
            },
          })
          this.$emit('cancel-topup')
          this.$bvModal.hide('modal-cancel-topup')
          this.loading = false
        })
        .catch(err => {
          const { meta } = err.response.data
          if (meta.code === 400) {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: 'Failed',
                text: meta.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContentVue,
              props: {
                title: 'Failed',
                text: 'This transaction was found',
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            })
          }
          this.loading = false
        })
    },
  },
}
</script>

<style scoped></style>
